import React, { useState, useEffect } from 'react';
import Footer from '../Footer';
import ContentsSidebar from './components/ContentsSidebar';
import { useParams } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import NotFoundPage from './NotFoundPage';
import { getFirestore } from 'firebase/firestore';
import posthog from 'posthog-js';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAPZA6Uw2WXWaKDyIA7utRLqWM9NcgKWNY",
  authDomain: "speechsdk.firebaseapp.com",
  databaseURL: "https://speechsdk-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "speechsdk",
  storageBucket: "speechsdk.appspot.com",
  messagingSenderId: "132583370615",
  appId: "1:132583370615:web:1d5b0e36078c3b40277b72"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const CanopyLabsModelReleases = ({releaseId}) => {
  const [BlogModule, setBlogModule] = useState(null);
  const [error, setError] = useState(null);

  // Dynamically import the content based on releaseId
  useEffect(() => {
    // Reset module state when releaseId changes
    setBlogModule(null);
    setError(null);

    // Build the path dynamically. This assumes your folders are named
    // exactly as the releaseId (e.g. "towards_human_sounding_tts")
    import(`./${releaseId}/content`)
      .then((module) => {
        // Expect the module to export a default component and a "sections" named export
        setBlogModule({
          BlogMain: module.default,
          sections: module.sections,
        });
      })
      .catch((err) => {
        console.error("Failed to load module for releaseId:", releaseId, err);
        setError(err);
      });
  }, [releaseId]);

  if (error) {
    return <NotFoundPage/>
  }

  if (!BlogModule) {
    return <div>Loading content...</div>;
  }

  const { BlogMain, sections } = BlogModule;

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-900">
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-start">
          <div className="hidden md:block">
            <ContentsSidebar sections={sections} />
          </div>
          <BlogMain />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CanopyLabsModelReleases;
